import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4a55855c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container inner" };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "media-split__left col-lg-6 mb-3" };
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = {
    key: 1,
    class: "iframe-wrapper"
};
const _hoisted_6 = { class: "media-split__right col-lg-6" };
const _hoisted_7 = ["src", "alt"];
const _hoisted_8 = {
    key: 1,
    class: "iframe-wrapper"
};
import { ref, onMounted } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'media_split',
    props: ['d'],
    setup(__props) {
        const props = __props;
        const leftVimeoPlayer = ref(null);
        const rightVimeoPlayer = ref(null);
        onMounted(() => {
            if (leftVimeoPlayer.value && props.d.left_vimeo_id) {
                const player = new Vimeo.Player(leftVimeoPlayer.value, {
                    id: props.d.left_vimeo_id,
                    responsive: true,
                    controls: false,
                    autoplay: true,
                    muted: true,
                });
                // Use Intersection Observer to detect when the component enters the viewport
                const options = {
                    root: null,
                    rootMargin: '0px',
                    threshold: 0.5, // Adjust this threshold as needed
                };
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            // Video is in view, play it
                            player.play().catch(console.error);
                        }
                        else {
                            // Video is out of view, pause it
                            player.pause().catch(console.error);
                        }
                    });
                }, options);
                observer.observe(leftVimeoPlayer.value);
            }
            if (rightVimeoPlayer.value && props.d.right_vimeo_id) {
                const player = new Vimeo.Player(rightVimeoPlayer.value, {
                    id: props.d.right_vimeo_id,
                    responsive: true,
                    controls: false,
                    autoplay: true,
                    muted: true,
                });
                // Use Intersection Observer to detect when the component enters the viewport
                const options = {
                    root: null,
                    rootMargin: '0px',
                    threshold: 0.5, // Adjust this threshold as needed
                };
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            // Video is in view, play it
                            player.play().catch(console.error);
                        }
                        else {
                            // Video is out of view, pause it
                            player.pause().catch(console.error);
                        }
                    });
                }, options);
                observer.observe(rightVimeoPlayer.value);
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", {
                class: "media-split",
                style: _normalizeStyle(`background-color: ${__props.d.background_colour ? __props.d.background_colour : '#fff'}`),
                ref: "thisModule"
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            (__props.d.left_image && !__props.d.left_vimeo_id)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: __props.d.left_image,
                                    alt: __props.d.left_image_alt_tag,
                                    class: "img-fluid"
                                }, null, 8, _hoisted_4))
                                : _createCommentVNode("", true),
                            (__props.d.left_vimeo_id)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    (__props.d.left_vimeo_id)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            ref_key: "leftVimeoPlayer",
                                            ref: leftVimeoPlayer,
                                            class: "video",
                                            id: "leftVimeoPlayer"
                                        }, null, 512))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            (__props.d.right_image && !__props.d.right_vimeo_id)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: __props.d.right_image,
                                    alt: __props.d.right_image_alt_tag,
                                    class: "img-fluid"
                                }, null, 8, _hoisted_7))
                                : _createCommentVNode("", true),
                            (__props.d.right_vimeo_id)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    (__props.d.right_vimeo_id)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            ref_key: "rightVimeoPlayer",
                                            ref: rightVimeoPlayer,
                                            class: "video",
                                            id: "rightVimeoPlayer"
                                        }, null, 512))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ])
            ], 4));
        };
    }
});
